module.exports = __webpack_public_path__ + "media/img/institutions/basic-plan-9c879add9c3afe76824fa754cb5b24da.svg";